export const SUGGESTED_TOPIC_GROUPS = [
    {
        group: 'The films',
        topics: [
            'Original Trilogy',
            'Prequel Trilogy',
            'Sequel Trilogy',
            'Rogue One',
            'Solo',
            'The Clone Wars (film)',
        ],
    },
    {
        group: 'Television',
        topics: [
            'The Clone Wars',
            'Rebels',
            'The Mandalorian',
            'Andor',
            'Ahsoka',
            'Obi-Wan Kenobi',
            'The Book of Boba Fett',
            'The Bad Batch',
            'Skeleton Crew',
            'The Acolyte',
            'Visions',
        ],
    },
    {
        group: 'Behind the camera',
        topics: [
            'Behind the Scenes',
            'Cast & Crew',
            'Music & Sound',
            'Effects & Design',
            'Production History',
            'Box Office & Awards',
        ],
    },
    {
        group: 'Beyond the screen',
        topics: ['Legends / Expanded Universe', 'Comics', 'Novels', 'Video Games', 'Toys & Merchandise'],
    },
    {
        group: 'Across the universe',
        topics: [
            'Characters',
            'Ships & Vehicles',
            'Planets & Locations',
            'The Force & the Jedi',
            'The Sith',
            'Droids',
            'Aliens & Species',
            'Weapons & Tech',
            'Quotes',
            'Timeline & Dates',
        ],
    },
];
/** Flat list, for a datalist or a plain search. */
export const SUGGESTED_TOPICS = SUGGESTED_TOPIC_GROUPS.flatMap((g) => g.topics);
/**
 * What the builder should offer: the suggested list plus anything already in
 * use, so a topic somebody invented last month is as easy to pick as a shipped
 * one. Case-insensitive on the merge, first spelling wins.
 */
export function mergeTopics(inUse) {
    const seen = new Map();
    for (const t of [...SUGGESTED_TOPICS, ...inUse]) {
        const key = t.trim().toLowerCase();
        if (key && !seen.has(key))
            seen.set(key, t.trim());
    }
    return [...seen.values()].sort((a, b) => a.localeCompare(b));
}
//# sourceMappingURL=topics.js.map